/* Storiz Theme — Global JS utilities
 * Placeholder — extend as needed.
 */
'use strict';

document.addEventListener('DOMContentLoaded', function () {
  // Smooth scroll for all anchor links pointing to #id
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
